<template lang="pug" src="./html/CryptoTradingIntroGuide.pug"></template>

<script>

  import Vue from 'vue'
  import ArticleItemBase from './ArticleItemBase'

  const CryptoTradingIntroGuideBody = () => import(/* webpackChunkName: "crypto-trading-intro-guide" */ './CryptoTradingIntroGuide-Body')

  Vue.component('CryptoTradingIntroGuideBody', CryptoTradingIntroGuideBody)

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setBody('CryptoTradingIntroGuideBody')
    }
  }
</script>

<style lang="sass" src="./style/ArticleItem.sass"></style>

<style lang="sass" src="./style/CryptoTradingIntroGuide.sass"></style>
